import { InputAdornment, TextField } from '@mui/material';
import type { V2NumericElement } from '../../../types/V2Types';
import type { V2ElementRendererProps } from './elementProps';

export function NumericElement({
	element,
	value,
	errors,
	disabled,
	onChange,
}: V2ElementRendererProps<V2NumericElement>) {
	const stringValue =
		typeof value === 'number' ? String(value) : typeof value === 'string' ? value : '';
	const errorMessage = errors[0]?.message;

	return (
		<TextField
			fullWidth
			type="number"
			value={stringValue}
			onChange={(e) => {
				const raw = e.target.value;
				if (raw === '') {
					onChange(null);
					return;
				}
				const n = Number(raw);
				onChange(Number.isFinite(n) ? n : raw);
			}}
			label={element.label}
			helperText={errorMessage ?? element.description}
			error={errors.length > 0}
			required={element.required}
			disabled={disabled}
			InputProps={{
				endAdornment: element.unit ? (
					<InputAdornment position="end">{element.unit}</InputAdornment>
				) : undefined,
			}}
			inputProps={{
				min: element.min,
				max: element.max,
				step: element.step,
				'data-cy': `hrr-element-${element.elementId}`,
				'data-element-type': 'numeric',
			}}
		/>
	);
}
